import { lazy } from "react";

const CustomBbvaUsageStatistics = lazy(() => import("./BbvaUsageStatistics/BbvaUsageStatistics"));

export default CustomBbvaUsageStatistics;
